import React from 'react'
import type { Icon } from 'shared/utils'
import { colors } from 'shared/assets/styles'

const { yellow } = colors

const CircleOffers = (props: Icon) => {
    const {
        color = 'white',
        background = yellow,
        size = 40,
        className = 'circle-offers'
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 40 40"
            preserveAspectRatio="none">
            <g fill="none" fillRule="evenodd">
                <circle cx={20} cy={20} r={20} fill={background} />
                <path
                    fill={color}
                    fillRule="evenodd"
                    d="M8.058 17.582a.987.987 0 01.29-.43c-.025 0 .107-.093.254-.131-.053.007.044-.02.146-.021H11v14H8.744c-.201 0-.376-.09-.523-.269A.999.999 0 018 30.075v-3.523c.217 0 .419-.055.605-.164.295-.174.536-.443.706-.777-.078.165.03-.05.108-.298.077-.248.116-.502.116-.761 0-.557-.148-1.03-.442-1.418-.295-.388-.659-.592-1.093-.612v-4.567c0-.139.02-.263.058-.373zm23.933 4.126a.957.957 0 01-.171.43c-.017.035-.117.13-.254.208-.137.08-.297.14-.48.179L29.66 23v-1.634c.512-.119.713-.376.604-.773l-1.371-4.784-2.44.832h-7.815l9.57-3.21-.604-2.11a.525.525 0 00-.274-.356.579.579 0 00-.44-.06l-13.763 4.637a.502.502 0 00-.328.297.719.719 0 00-.055.475l.11.327h-1.509l-.301-1.07a.927.927 0 01.055-.698.86.86 0 01.52-.46l15.958-5.38a.921.921 0 01.445-.013c.14.029.272.103.391.222a.852.852 0 01.233.416l3.318 11.678a.855.855 0 01.027.372zm-3.232-4.424c.16.19.241.413.241.671v.926a.276.276 0 00-.134-.03.852.852 0 00-.642.283.946.946 0 00-.268.672c0 .259.09.483.268.672.178.19.392.283.642.283H29v.866h-.134a.852.852 0 00-.642.283.946.946 0 00-.268.672.938.938 0 00.455.821c.13.085.286.134.453.134H29v.866h-.134-.001a.838.838 0 00-.458.137.94.94 0 00-.45.818c0 .26.088.483.267.672.178.19.392.284.642.284H29v.865h-.134a.85.85 0 00-.642.284.946.946 0 00-.268.671c0 .26.09.483.268.672a.85.85 0 00.642.284H29v.985c0 .159-.036.313-.107.462a.769.769 0 01-.403.39c-.038.033-.177.073-.32.073H13V17h15.17c.232 0 .429.095.59.284z"
                />
            </g>
        </svg>
    )
}

export { CircleOffers }
